module.exports = __webpack_public_path__ + "img/f3.c942e50f.png";